import * as React from 'react';

function SvgStarEmpty(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.768 23.516a.687.687 0 00.806 0l5.204-3.783 5.204 3.783a.687.687 0 001.055-.766l-1.986-6.122 5.222-3.796a.685.685 0 00-.403-1.24h-6.454L15.43 5.474a.685.685 0 00-1.304 0l-1.986 6.118H5.686a.686.686 0 00-.403 1.24l5.223 3.796L8.52 22.75a.686.686 0 00.248.766zm6.414-5.185a.69.69 0 00-.807 0l-3.9 2.835 1.489-4.588a.685.685 0 00-.249-.766l-3.92-2.85h4.843c.297 0 .56-.19.652-.473l1.488-4.583 1.487 4.583a.685.685 0 00.652.473h4.844l-3.92 2.85a.685.685 0 00-.248.766l1.489 4.588-3.9-2.835z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgStarEmpty;
